module.exports = {
          srcSet: __webpack_public_path__ + "f743938eec1dc7cac79e7ee2e8acdbdc-320.png"+" 320w",
          images:[ {path: __webpack_public_path__ + "f743938eec1dc7cac79e7ee2e8acdbdc-320.png",width: 320,height: 200}],
          src: __webpack_public_path__ + "f743938eec1dc7cac79e7ee2e8acdbdc-320.png",
          toString:function(){return __webpack_public_path__ + "f743938eec1dc7cac79e7ee2e8acdbdc-320.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAYElEQVR4nIXOOwqDUBCF4S9aZV02apcmCxDtxMYEAkmZjWSnYfQWV7jgD4d5HWaGnSrFoE6K3iXLtyK4ZuYiD6z44ocRH7Ro8MYcxh53dHhhwhMDbmnRcnbtQPxYUj6v/gTRCFKKbPLsAAAAAElFTkSuQmCC",
          width: 320,
          height: 200
        }